<template>
    <div>
        <b-alert :show="errors.any()" variant="danger" class="px-4">
            <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{err}}</li>
            </ul>
        </b-alert>
        <div class="text-dark mb-2 h6">
                <span v-if="dateInfo.orderType === 'Pickup'">
                    Please confirm pickup time.
                </span>
            <span v-else>
                    Please confirm delivery time.
                </span>
        </div>
        <div v-if="dateInfo.orderType === 'Pickup'">
            <div v-if="EnableScheduledPickup">
                <div class="mb-3" v-if="dateInfo.special">
                    <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'">
                        <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'" v-validate="'required'" @change="changeDate" :options="dates" v-model="date"/>
                    </b-input-group>
                </div>
                <div :class="dateInfo.special ? 'mt-3' : 'mb-3'">
                    <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'">
                        <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'" v-validate="'required'" :options="times" v-model="time"/>
                    </b-input-group>
                </div>
            </div>
            <div v-else>
                <div v-if="dateInfo.special">
                    <div class="mb-3" v-if="dateInfo.special">
                        <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'">
                            <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'" v-validate="'required'" @change="changeDate" :options="dates" v-model="date"/>
                        </b-input-group>
                    </div>
                    <div :class="dateInfo.special ? 'mt-3' : 'mb-3'">
                        <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'">
                            <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'" v-validate="'required'" :options="times" v-model="time"/>
                        </b-input-group>
                    </div>
                </div>
                <div v-else>
                    <p>{{getCurrentHour()}}</p>
                </div>
            </div>
        </div>
        <div v-else>
            <div>
                <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'">
                    <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'" v-validate="'required'" :options="times" v-model="time"/>
                </b-input-group>
            </div>
        </div>
        <b-row class="flex-grow-1 mt-3">
            <b-col cols="6">
                <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="create">
                    <span v-if="byLink">Confirm</span>
                    <span v-else>
                        <span v-if="fromReport">Charge Card</span>
                        <span v-else>Pay</span>
                    </span>
                    <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                </b-btn>
            </b-col>

            <b-col cols="6">
                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="cancel">
                    Cancel
                </b-btn>
            </b-col>
        </b-row>
    </div>
<!--    <b-card no-body class="m-0">-->
<!--        <b-card-header>-->
<!--            <span>-->
<!--                Confirmation-->
<!--            </span>-->
<!--        </b-card-header>-->
<!--        <b-card-body>-->
<!--            <b-alert :show="errors.any()" variant="danger" class="px-4">-->
<!--                <ul class="m-0 px-1">-->
<!--                    <li v-for="err in errors.all()" :key="err">{{err}}</li>-->
<!--                </ul>-->
<!--            </b-alert>-->
<!--            <div class="text-dark mb-2 h6">-->
<!--                <span v-if="dateInfo.orderType === 'Pickup'">-->
<!--                    Please confirm pickup time.-->
<!--                </span>-->
<!--                <span v-else>-->
<!--                    Please confirm delivery time.-->
<!--                </span>-->
<!--            </div>-->
<!--            <div v-if="dateInfo.orderType === 'Pickup'">-->
<!--                <div v-if="EnableScheduledPickup">-->
<!--                    <div class="mb-3" v-if="dateInfo.special">-->
<!--                        <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'">-->
<!--                            <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'" v-validate="'required'" @change="changeDate" :options="dates" v-model="date"/>-->
<!--                        </b-input-group>-->
<!--                    </div>-->
<!--                    <div :class="dateInfo.special ? 'mt-3' : 'mb-3'">-->
<!--                        <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'">-->
<!--                            <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'" v-validate="'required'" :options="times" v-model="time"/>-->
<!--                        </b-input-group>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-else>-->
<!--                    <div v-if="dateInfo.special">-->
<!--                        <div class="mb-3" v-if="dateInfo.special">-->
<!--                            <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'">-->
<!--                                <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Date' : 'Delivery Date'" v-validate="'required'" @change="changeDate" :options="dates" v-model="date"/>-->
<!--                            </b-input-group>-->
<!--                        </div>-->
<!--                        <div :class="dateInfo.special ? 'mt-3' : 'mb-3'">-->
<!--                            <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'">-->
<!--                                <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'" v-validate="'required'" :options="times" v-model="time"/>-->
<!--                            </b-input-group>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                        <p>{{getCurrentHour()}}</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <div>-->
<!--                    <b-input-group :prepend="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'">-->
<!--                        <b-form-select :name="dateInfo.orderType === 'Pickup' ? 'Pickup Time' : 'Delivery Time'" v-validate="'required'" :options="times" v-model="time"/>-->
<!--                    </b-input-group>-->
<!--                </div>-->
<!--            </div>-->


<!--            <div class="d-flex flex-row mt-3 justify-content-between">-->
<!--                <b-btn class="cancelBtnModal" :disabled="loading" @click="create">-->
<!--                    <span v-if="byLink">Confirm</span>-->
<!--                    <span v-else>-->
<!--                        <span v-if="fromReport">Charge Card</span>-->
<!--                        <span v-else>Pay</span>-->
<!--                    </span>-->
<!--                </b-btn>-->
<!--                <b-btn class="processBtnModal" @click="cancel">-->
<!--                    <span>Cancel</span>-->
<!--                </b-btn>-->
<!--            </div>-->
<!--        </b-card-body>-->
<!--    </b-card>-->
</template>

<script>
    import moment from "moment";

    export default {
        name: "confirmDate",
        props: {
            dateInfo: {required: true},
            loading: {required: true},
            byLink: {required: false},
            fromReport: {required: false},
            EnableScheduledPickup: {required: false},
            PreparationTime: {required: false}
        },
        data () {
            return {
                date: null,
                time: null,
                dates: [],
                times: [],
                availableTime: false,
                availableDate: false
            }
        },
        mounted() {
            if (this.dateInfo.orderType === 'Delivery') {
                this.getAllDeliveryTimes()
            } else {
                if (this.dateInfo.special) {
                    this.getDates()
                } else {
                    this.getAllPickUpTimes()
                }
            }
        },
        methods: {
            validDate (date) {
                moment.locale('en-ca');
                return moment(date).format('D MMM YY')
            },
            getAllPickUpTimes () {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                this.$api.getRestaurant.GetPickupTimes(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.times.forEach((item, index) => {
                            array.push({
                                text: index === 0 ? item + ' (ASAP) ' : item,
                                value: item
                            })
                        })
                        this.times = [{text: 'Chooose one of the items...', value: null}, ...array]
                        let findSelectedTime = this.times.find(i => i.text == this.dateInfo.time)
                        if (findSelectedTime) {
                            this.time = findSelectedTime.value
                            this.availableTime = true
                        } else {
                            this.time = this.times[1].value
                            this.availableTime = false
                        }
                    }
                }).catch(err => {

                })
            },
            getAllDeliveryTimes () {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                this.$api.getRestaurant.GetDeliveryTimes(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.listOfRestaurantDeliveryPeriod.forEach((item, index) => {
                            array.push({
                                text: index === 0 ? item.PickupTime + ' (ASAP) ' : item.PickupTime,
                                value: item.PickupTime
                            })
                        })
                        this.times = [{text: 'Chooose one of the items...', value: null}, ...array]
                        let findSelectedTime = this.times.find(i => i.text == this.dateInfo.time)
                        if (findSelectedTime) {
                            this.time = findSelectedTime.value
                            this.availableTime = true
                        } else {
                            this.time = this.times[1].value
                            this.availableTime = false
                        }
                    }
                }).catch(err => {

                })
            },
            getDates () {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType: 'Food',
                    ItemType: 'Food',
                    MenuTypeID: this.dateInfo.specialMenuTypeId
                }
                this.$api.getRestaurant.GetPickupDateByMenu(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.dates.forEach(item => {
                            array.push({
                                text: this.validDate(item),
                                value: item
                            })
                        })
                        this.dates = [{text: 'Chooose one of the items...', value: null}, ...array]
                        let findSelectedDate = this.dates.find(i => i.value == this.dateInfo.date)
                        if (findSelectedDate) {
                            this.date = findSelectedDate.value
                            this.GetPickupTimes_Event(this.date, this.dateInfo.specialMenuTypeId, false)
                            this.availableDate = true
                        } else {
                            this.date = this.dates[1].value
                            this.GetPickupTimes_Event(this.date, this.dateInfo.specialMenuTypeId, false)
                            this.availableDate = false
                        }
                    }
                }).catch(err => {

                })
            },
            changeDate (date) {
                if (date === null) {
                    this.times = []
                    this.time = null
                } else {
                    this.GetPickupTimes_Event(date, this.dateInfo.specialMenuTypeId, true)
                }
            },
            GetPickupTimes_Event (SelectedDate, MenuTypeID, changed) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    SelectedDate,
                    MenuTypeID
                }
                this.$api.getRestaurant.GetPickupTimes_Event(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.times.forEach((item, index) => {
                            array.push({
                                text: index === 0 ? item + ' (ASAP) ' : item,
                                value: item
                            })
                        })
                        this.times = [{text: 'Chooose one of the items...', value: null}, ...array]
                        if (changed) {
                            this.time = null
                        } else {
                            let findSelectedTime = this.times.find(i => i.text == this.dateInfo.time)
                            if (findSelectedTime) {
                                this.time = findSelectedTime.value
                                this.availableTime = true
                            } else {
                                this.time = this.times[1].value
                                this.availableTime = false
                            }
                        }
                    }
                }).catch(err => {

                })
            },
            cancel () {
                this.$emit('cancelConfirmation', false)
            },
            create () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        if (this.dateInfo.orderType === 'Pickup') {
                            if (this.dateInfo.special) {
                                this.$emit('createFinalyOrder', {
                                    date: this.date,
                                    time: this.time
                                })
                            } else {
                                if (this.EnableScheduledPickup) {
                                    this.$emit('createFinalyOrder', {
                                        date: this.date,
                                        time: this.time
                                    })
                                } else {
                                    this.$emit('createFinalyOrder', {
                                        date: this.date,
                                        time: this.getCurrentHour()
                                    })
                                }
                            }
                        } else {
                            this.$emit('createFinalyOrder', {
                                date: this.date,
                                time: this.time
                            })
                        }
                    }
                })
            },
            getCurrentHour () {
                const currentTime = moment().locale('en').add(this.PreparationTime, 'minutes').format('hh:mm A')
                return currentTime
            }
        }
    }
</script>

<style scoped>

</style>
